import { motion, useReducedMotion } from "framer-motion";
import { springTransition } from "@/lib/motionVariants";

export default function MotionButton({
    children,
    className,
    href,
    onClick,
    type = "button",
    ...props
}) {
    const reduceMotion = useReducedMotion();
    const hover = reduceMotion
        ? {}
        : {
              whileHover: { y: -3, scale: 1.03 },
              whileTap: { scale: 0.97, y: 0 },
          };

    if (href) {
        return (
            <motion.a
                href={href}
                className={className}
                transition={springTransition}
                {...hover}
                {...props}
            >
                {children}
            </motion.a>
        );
    }

    return (
        <motion.button
            type={type}
            onClick={onClick}
            className={className}
            transition={springTransition}
            {...hover}
            {...props}
        >
            {children}
        </motion.button>
    );
}
